import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function KnowYourCost() {
  const [formData, setFormData] = useState({
    user_email: "",
    unique_users: "",
    total_documents: "",
    average_doc_size_mb: "",
    avg_words_per_doc: "",
    total_data_gb: "",
    annual_growth_percent: "",
    ai_requests_per_month: "",
    avg_words_per_prompt: "",
    avg_words_per_response: "",
  });

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = new FormData();
    for (let key in formData) {
      data.append(key, formData[key]);
    }

    const config = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}submit-usage`,
      headers: {
        "api-key": `${process.env.REACT_APP_API_KEY}`,
        ...data.getHeaders?.(),
      },
      data: data,
    };

    try {
      const response = await axios(config);
      toast.success(response.data.message || "Submitted successfully!");
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          "Something went wrong. Please try again."
      );
    }
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      {/* Invoice page start */}
      <div
        className="text-center text-white bg_header mb-5"
        style={{
          background:
            "url('https://img.freepik.com/free-photo/cheese-spaghetti-pasta-white-blank-paper-black-backdrop_23-2148087356.jpg?t=st=1741086231~exp=1741089831~hmac=7c7c2a179456a6bd8a0572cb8420bd3c9aff4639dbd9fef4eca5c42977ba5c5c&w=1380') center/cover",
          padding: "180px 0",
        }}
      >
        <h1 className="fw-bold mb-4">
          Know Your Cost For
          <span className="primary_text"> AIVIO</span>
        </h1>
       
      </div>

      {/* Form 27-5-2025 start */}
      <div className="container">
        <div className="info-highlight-box">
          <div className="intro-text">
            <p>
              <strong>
                To provide you with an accurate and transparent cost estimate
                for using <strong>Aivio</strong>, we need a few key details
                about your expected usage. This helps us:
              </strong>
            </p>
          </div>

          <div className="info-points">
            <div className="info-item">
              <span className="icon">⚙️</span>
              <p>Optimize the solution based on your actual needs</p>
            </div>
            <div className="info-item">
              <span className="icon">📊</span>
              <p>Estimate infrastructure and AI processing resources</p>
            </div>
            <div className="info-item">
              <span className="icon">💰</span>
              <p>Suggest a suitable pricing model based on volume and growth</p>
            </div>
          </div>

          <div className="note">
            <p className="mb-0">
              <em>No need to be exact — approximate values are okay!</em>
            </p>
          </div>
        </div>
        <div className="main-card">
          <h1 className="form-title">Usage Estimation Form</h1>
          <form className="user-form" onSubmit={handleSubmit}>
            <div className="form-section">
              <div className="email-box mb-5">
                <label>Your Email Address:</label>
                <input
                  type="email"
                  name="user_email"
                  placeholder="example@yourdomain.com"
                  onChange={handleChange}
                  required
                />
                <p className="note small">
                  We’ll use this to send you the estimated cost based on your
                  inputs.
                </p>
              </div>

              <h2>User Activity</h2>
              <div className="row">
                <div className="col-md-12 mb-3">
                  <label>Unique users per month:</label>
                  <input
                    type="number"
                    placeholder="e.g., 150"
                    name="unique_users"
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
            </div>

            <div className="form-section">
              <h2>Document and Data Volume</h2>
              <div className="row">
                <div className="col-lg-4 col-md-6 mb-3">
                  <label>Total documents to be processed:</label>
                  <input
                    type="number"
                    placeholder="e.g., 10,000"
                    onChange={handleChange}
                    name="total_documents"
                  />
                </div>
                <div className="col-lg-4 col-md-6 mb-3">
                  <label>Average size of each document (MB):</label>
                  <input
                    type="number"
                    placeholder="e.g., 2.5"
                    step="0.1"
                    name="average_doc_size_mb"
                    onChange={handleChange}
                  />
                </div>
                <div className="col-lg-4 col-md-6 mb-3">
                  <label>Average number of words per document:</label>
                  <input
                    type="number"
                    placeholder="e.g., 1,200"
                    name="avg_words_per_doc"
                    onChange={handleChange}
                  />
                </div>
                <div className="col-lg-6 col-md-6 mb-3">
                  <label>Total data volume to be processed (GB):</label>
                  <input
                    type="number"
                    step="0.1"
                    placeholder="e.g., 25.4"
                    onChange={handleChange}
                    name="total_data_gb"
                  />
                </div>
                <div className="col-lg-6 col-md-12 mb-3">
                  <label>Expected annual data volume growth (%):</label>
                  <input
                    type="number"
                    name="annual_growth_percent"
                    placeholder="e.g., 15"
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>

            <div className="form-section">
              <h2>AI Interaction Volume</h2>
              <div className="row">
                <div className="col-md-4 mb-3">
                  <label>AI-based requests per month:</label>
                  <input
                    type="number"
                    name="ai_requests_per_month"
                    placeholder="e.g., 5000"
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-4 mb-3">
                  <label>Average words per prompt:</label>
                  <input
                    type="number"
                    name="avg_words_per_prompt"
                    placeholder="e.g., 100"
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-4 mb-3">
                  <label>Average words per response:</label>
                  <input
                    type="number"
                    name="avg_words_per_response"
                    placeholder="e.g., 150"
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>

            <div className="submit-box">
              <button type="submit">Submit</button>
            </div>
          </form>
        </div>
      </div>
      {/* Form 27-5-2025 End */}
    </>
  );
}

export default KnowYourCost;
